import { calculateBigTag } from '../big_tag'

function filterTags(recentTags, tags, search) {
    if (!search) return recentTags
    const searchLower = search.toLowerCase()

    const tagIds = tags.sort
    const tagItems = tags.items

    const recentTagIndexes = recentTags.reduce((acc, item, i) => Object.assign({}, acc, {[item.tag]: i }), {})

    const filteredTagIds = tagIds.filter(tagId => {
        const foundTag = tagItems[tagId]
        return foundTag && foundTag.name.toLowerCase().match(searchLower)
    })

    return filteredTagIds.map(tagId => {
        const recentTag = recentTags[recentTagIndexes[tagId]]
        return recentTag || {
            "tag": tagId,
            "totalDuration": 0,
            "interval": "this month",
        }
    })
}

export function calculateTeamTags(tags, team) {
    return tags.sort.reduce((acc, k) => [...acc, tags.items[k]], [])
        .filter(t => t.teamId === team.id)
        .sort((a, b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1)
}

export function formatRecentBigTags(recentTags, tags, search, profile, teams) {
    if (!recentTags || !tags.sort) return []
    if (recentTags.length === 0 || tags.sort.length === 0) return []

    const filteredTags = filterTags(recentTags, tags, search)
    const tagItems = tags.items

    return filteredTags.map(recentTag => {
        const foundTag   = tagItems[recentTag.tag]
        return calculateBigTag(foundTag, recentTag.totalDuration, profile, teams)
    })
}


// WEBPACK FOOTER //
// ./src/common/components/layout/tag_sidebar.js